/**
 * custom-tag-badge-fix.js
 *
 * 商品タグ連動バッジ（商品名下の「家庭洗濯」等と、画像左上の「送料無料」バッジ）が、
 * Boost等のアプリによって商品一覧が作り直された際に消えてしまう場合の保険用スクリプトです。
 *
 * データは以下の3段階で取得する：
 *   1. collection-template.liquid が埋め込む JSON（#custom-tag-badge-data）
 *   2. 実際にDOM上で見つけたバッジのキャッシュ
 *   3. 1,2 にない新しい商品（Boostが別ページ分を差し替えた場合など）は、
 *      Shopifyの公開 JSON（/products/ハンドル.js）を取得して自分で作る
 *
 * ※ TOP・collectionページだけはメール便送料無料タグの表示を「メール便無料」に短縮
 */
(function () {
  var META_SELECTOR = '.grid-product__meta';
  var CONTENT_SELECTOR = '.grid-product__content';
  var BADGE_SELECTOR = '.custom-tag-badge-wrap';
  var SHIPPING_SELECTOR = '.grid-product__tag--shipping-custom';
  var TAGS_WRAP_SELECTOR = '.grid-product__tags';
  var LINK_SELECTOR = '.grid-product__link';
  var DATA_SCRIPT_ID = 'custom-tag-badge-data';
  var MAX_BADGES = 3;

  // custom-tag-badges.liquid の limited_ok_tags と同じ順番・同じルール
  var TAG_BADGE_RULES = [
    { tag: 'ロングセラー', cls: 'custom-tag-badge--black', label: 'ロングセラー' },
    { tag: '洗濯機可', cls: 'custom-tag-badge--blue', label: '洗濯機可' },
    { tag: '家庭洗濯', cls: 'custom-tag-badge--blue', label: '家庭洗濯', suppressIfTag: '洗濯機可' },
    { tag: '銀座本店おすすめ', cls: 'custom-tag-badge--pink', label: '銀座本店おすすめ' },
    { tag: '東銀座店おすすめ', cls: 'custom-tag-badge--pink', label: '東銀座店おすすめ' },
    { tag: '自由が丘店おすすめ', cls: 'custom-tag-badge--pink', label: '自由が丘店おすすめ' },
    { tag: '吉祥寺店おすすめ', cls: 'custom-tag-badge--pink', label: '吉祥寺店おすすめ' },
    { tag: 'つくば店おすすめ', cls: 'custom-tag-badge--pink', label: 'つくば店おすすめ' },
    { tag: '浦和美園店おすすめ', cls: 'custom-tag-badge--pink', label: '浦和美園店おすすめ' },
    { tag: '富士見店おすすめ', cls: 'custom-tag-badge--pink', label: '富士見店おすすめ' }
  ];

  // 商品ハンドル -> 下のタグバッジHTML
  var badgeDataMap = {};
  // 商品ハンドル -> 送料無料バッジのラベル文字（'' = 表示不要）
  var shippingDataMap = {};
  var fetchingHandles = {};

  function buildBadgeHtmlFromTags(tags) {
    var count = 0;
    var spans = '';
    for (var i = 0; i < TAG_BADGE_RULES.length; i++) {
      if (count >= MAX_BADGES) break;
      var rule = TAG_BADGE_RULES[i];
      if (rule.suppressIfTag && tags.indexOf(rule.suppressIfTag) !== -1) continue;
      if (tags.indexOf(rule.tag) !== -1) {
        spans += '<span class="custom-tag-badge ' + rule.cls + '">' + rule.label + '</span>';
        count++;
      }
    }
    return '<div class="custom-tag-badge-wrap">' + spans + '</div>';
  }

  function buildShippingLabelFromTags(tags) {
    if (tags.indexOf('送料無料') !== -1) return '送料無料';
    if (tags.indexOf('メール便送料無料') !== -1) return 'メール便無料';
    return '';
  }

  function loadBadgeDataMap() {
    var el = document.getElementById(DATA_SCRIPT_ID);
    if (!el) return;
    try {
      var parsed = JSON.parse(el.textContent);
      for (var handle in parsed) {
        if (Object.prototype.hasOwnProperty.call(parsed, handle)) {
          badgeDataMap[handle] = parsed[handle].badge;
          shippingDataMap[handle] = parsed[handle].shipping;
        }
      }
    } catch (e) {
      console.log('[custom-tag-badge-fix] failed to parse badge data JSON', e);
    }
  }

  function getHandleFromMeta(meta) {
    var link = meta.closest(LINK_SELECTOR) || meta.closest('a[href]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    var clean = href.split('?')[0].split('#')[0];
    var parts = clean.split('/').filter(function (p) { return p.length > 0; });
    return parts.length ? parts[parts.length - 1] : null;
  }

  function cacheExistingBadges() {
    var metas = document.querySelectorAll(META_SELECTOR);
    for (var i = 0; i < metas.length; i++) {
      var meta = metas[i];
      var handle = getHandleFromMeta(meta);
      if (!handle) continue;

      var badge = meta.querySelector(BADGE_SELECTOR);
      if (badge && badge.innerHTML.trim() !== '') {
        badgeDataMap[handle] = badge.outerHTML;
      }

      var content = meta.closest(CONTENT_SELECTOR);
      if (content) {
        var shipping = content.querySelector(SHIPPING_SELECTOR);
        if (shipping && shipping.textContent.trim() !== '') {
          shippingDataMap[handle] = shipping.textContent.trim();
        }
      }
    }
  }

  function fetchAndCacheBadge(handle) {
    if (fetchingHandles[handle]) return;
    fetchingHandles[handle] = true;
    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var tags = (data && data.tags) ? data.tags : [];
        badgeDataMap[handle] = buildBadgeHtmlFromTags(tags);
        shippingDataMap[handle] = buildShippingLabelFromTags(tags);
        console.log('[custom-tag-badge-fix] fetched tags for handle=' + handle);
        restoreMissingBadges();
      })
      .catch(function (err) {
        console.log('[custom-tag-badge-fix] fetch failed for handle=' + handle, err);
      })
      .then(function () {
        delete fetchingHandles[handle];
      });
  }

  function restoreBelowTitleBadge(meta, handle) {
    var html = badgeDataMap[handle];
    if (typeof html === 'undefined') return;

    var existing = meta.querySelector(BADGE_SELECTOR);
    if (!existing) {
      if (html.indexOf('<span') !== -1) {
        meta.insertAdjacentHTML('afterbegin', html);
        console.log('[custom-tag-badge-fix] restored (re-inserted) for handle=' + handle);
      }
    } else {
      var cs = window.getComputedStyle(existing);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') {
        existing.style.removeProperty('display');
        existing.style.removeProperty('visibility');
        existing.style.removeProperty('opacity');
        console.log('[custom-tag-badge-fix] restored (was hidden via CSS) for handle=' + handle);
      } else if (existing.innerHTML.trim() === '' && html.indexOf('<span') !== -1) {
        existing.outerHTML = html;
        console.log('[custom-tag-badge-fix] restored (was empty) for handle=' + handle);
      }
    }
  }

  function restoreShippingBadge(content, handle) {
    if (!content) return;
    var label = shippingDataMap[handle];
    if (typeof label === 'undefined' || label === '') return;

    var existingShipping = content.querySelector(SHIPPING_SELECTOR);
    if (existingShipping) return;

    var shippingDiv = document.createElement('div');
    shippingDiv.className = 'grid-product__tag grid-product__tag--shipping-custom';
    shippingDiv.textContent = label;

    var wrap = content.querySelector(TAGS_WRAP_SELECTOR);
    if (wrap) {
      wrap.appendChild(shippingDiv);
    } else {
      wrap = document.createElement('div');
      wrap.className = 'grid-product__tags';
      wrap.appendChild(shippingDiv);
      content.insertBefore(wrap, content.firstChild);
    }
    console.log('[custom-tag-badge-fix] restored shipping badge for handle=' + handle);
  }

  function restoreMissingBadges() {
    var metas = document.querySelectorAll(META_SELECTOR);
    for (var i = 0; i < metas.length; i++) {
      var meta = metas[i];
      var handle = getHandleFromMeta(meta);
      if (!handle) continue;

      var needFetch = (typeof badgeDataMap[handle] === 'undefined') || (typeof shippingDataMap[handle] === 'undefined');
      if (needFetch) {
        fetchAndCacheBadge(handle);
      }

      restoreBelowTitleBadge(meta, handle);

      var content = meta.closest(CONTENT_SELECTOR);
      restoreShippingBadge(content, handle);
    }
  }

  function init() {
    loadBadgeDataMap();
    cacheExistingBadges();
    console.log('[custom-tag-badge-fix] initialized. known badges:', Object.keys(badgeDataMap).length);

    restoreMissingBadges();

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        cacheExistingBadges();
        restoreMissingBadges();
        scheduled = false;
      }, 100);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    setInterval(function () {
      restoreMissingBadges();
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
